import { type LoaderFunctionArgs, useRouteLoaderData } from "react-router";

import AssessmentApi from "@/api/assessment-api";
import AssignmentApi from "@/api/assignment-api";
import CandidateList from "@/components/candidate-list";
import { usePageTitle } from "@/hooks/title";
import type { AssignmentLoaderData } from "@/types/assignment";
import type { CandidatesUnderAssessment } from "@/types/candidate";
import type { Competency } from "@/types/competency";
import type { AssignmentScorecards } from "@/types/scorecard";

export default function SingleAssignment() {
  const { assignment } = useRouteLoaderData("single-assignment") as AssignmentLoaderData;
  usePageTitle(assignment.name);

  return (
    <div className="mx-auto max-w-[60rem]">
      <CandidateList candidates={assignment.candidates} assignment={assignment} />
    </div>
  );
}

export type LoaderData = {
  scorecards: AssignmentScorecards;
  competencies: Competency[];
  assessments: CandidatesUnderAssessment;
};

export async function loader({
  request,
  params: { assignment_id },
}: LoaderFunctionArgs): Promise<LoaderData> {
  if (!assignment_id) {
    throw new Error("Assignment ID is required");
  }
  const { data: scorecards } = await AssessmentApi.getAssignmentScorecards(
    assignment_id,
    request.signal,
  );
  const { data: assessments } = await AssessmentApi.getAssessments(assignment_id, request.signal);
  const { data: competencies } = await AssignmentApi.getAssignmentCompetencies(
    assignment_id,
    request.signal,
  );
  return {
    scorecards: scorecards ?? {},
    competencies: competencies ?? [],
    assessments: assessments ?? {
      all_competencies_count: 0,
      user_competencies_count: 0,
      candidates: [],
    },
  };
}
